import BulkUnsubscribeForm from '../components/Unsubscribes/BulkUnsubscribeForm';

export default function UnsubscribesPage() {
  return <BulkUnsubscribeForm />;
}
